import React, { useCallback, useMemo, useState } from "react";
import { useGetNews } from "src/modules/api/Notification/useGetNews";
import { MypageSectionTitle } from "../mypageSectionTitle";
import { NewsItemDetail } from "./newsItemDetail";
import { NewsItemTitleList } from "./newsItemTitleList";
import styles from "./style.module.scss";

export const NewsBody = React.memo(() => {
  const { data, isLoading } = useGetNews();

  const [selectedNewsItemId, setSelectedNewsId] = useState<number | null>(null);
  const resetSelectedNewsId = useCallback(() => setSelectedNewsId(null), []);
  const newsItemList = useMemo(
    () => (typeof data !== "undefined" ? data.news_list : []),
    [data]
  );
  const selectedNewsItem = useMemo(
    () => newsItemList.find((newsItem) => newsItem.id === selectedNewsItemId),
    [newsItemList, selectedNewsItemId]
  );

  if (isLoading) {
    return <></>;
  }
  return (
    <div className={styles.newsBody}>
      <MypageSectionTitle>お知らせ</MypageSectionTitle>
      <div>
        {typeof selectedNewsItem === "undefined" ? (
          <NewsItemTitleList
            newsItemList={newsItemList}
            setSelectedNewsId={setSelectedNewsId}
          />
        ) : (
          <NewsItemDetail
            selectedNewsItem={selectedNewsItem}
            resetSelectedNewsId={resetSelectedNewsId}
          />
        )}
      </div>
    </div>
  );
});
